import { isCompliancePath } from '@/features/compliance/lib/constants'
import { SIGNUP_PATHS } from '@/features/user/signup/helpers'

const EXEMPT_PATH_FRAGMENTS = ['/signup', '/accounts']

/**
 * Where a user with no app access should be sent from `pathname`, or `null` to leave them
 * where they are.
 *
 * @param search - the current location's query string (including the leading `?`), carried
 * over onto the redirect target so a link like `?trial=freetrial2026` survives the bounce
 * into signup instead of landing the user on the target page with no trial context.
 */
export const getNoAppAccessRedirect = ({
  pathname,
  search,
  lastOnboardingScreen,
}: {
  pathname: string
  search?: string
  lastOnboardingScreen: string | null | undefined
}): string | null => {
  // Checked before the fragment list on purpose: the funnel paths do not contain "/signup",
  // so the generic exemption would not cover them.
  if (isCompliancePath(pathname)) {
    return null
  }

  if (EXEMPT_PATH_FRAGMENTS.some((fragment) => pathname.includes(fragment))) {
    return null
  }

  // A funnel user landing anywhere else resumes where they left off rather than being
  // swept into standard onboarding.
  const target = isCompliancePath(lastOnboardingScreen ?? '')
    ? (lastOnboardingScreen ?? null)
    : SIGNUP_PATHS.aboutYourPractice

  return target && search ? `${target}${search}` : target
}
